import { ModuleProvider, useModule } from '#providers'
import { BudgetEstimatesModuleData } from './types/budgetEstimates.types'

export const BudgetModuleProvider: typeof ModuleProvider<BudgetEstimatesModuleData> =
	ModuleProvider

export const useBudgetModule: typeof useModule<BudgetEstimatesModuleData> =
	useModule
